<template>
    <div id="payment-failure-page">
        <AppHero
            :heading="'Your Purchase was not completed Successfully'"
        >
            <p class="body-copy body-copy--align-center">Try again</p>
        </AppHero>
    </div>
</template>

<script>
    import AppHero from "@/components/layout/AppHero";

    export default {
        name: 'PaymentFailurePage',
        metaInfo: {
            title: 'Khonsu - PaymentFailurePage'
        },
        components: {
            AppHero,
        }
    }
</script>